import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import useLocationInfo from '@src/hooks/useLocation';
import ROUTE from '@src/constants/route';
import useFeatureFlags from '@src/hooks/useFeatureFlags';

const PrivateRoute = ({ component: Component, featureKey, ...rest }) => {
  const { ip } = useLocationInfo();
  const { accessToken, user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();

  const enabled = featureKey
    ? getFeatureValue(featureKey, {
        userId: user?.id,
        email: user?.email,
        phoneNumber: user?.phoneNumber,
        ip,
      })
    : true;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!enabled) return <Redirect to={ROUTE.TTS} />;
        if (accessToken) return <Component {...props} />;
        return null;
      }}
    />
  );
};

export default PrivateRoute;
